"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Player = void 0;
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _CogManager = require("../../utils/CogManager");
var _colliderComponent2 = require("../components/collider/collider-component");
var _eventBusComponent2 = require("../components/events/event-bus-component");
var _healthComponent2 = require("../components/health/health-component");
var _cogInputComponent = require("../components/input/cog-input-component");
var _keyboardInputComponent2 = require("../components/input/keyboard-input-component");
var _horizontalMovementComponent2 = require("../components/movement/horizontal-movement-component");
var _weaponComponent2 = require("../components/weapon/weapon-component");
var CONFIG = _interopRequireWildcard(require("../config"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _keyboardInputComponent = /*#__PURE__*/new WeakMap();
var _healthComponent = /*#__PURE__*/new WeakMap();
var _weaponComponent = /*#__PURE__*/new WeakMap();
var _horizontalMovementComponent = /*#__PURE__*/new WeakMap();
var _colliderComponent = /*#__PURE__*/new WeakMap();
var _eventBusComponent = /*#__PURE__*/new WeakMap();
var _shipSprite = /*#__PURE__*/new WeakMap();
var _shipEngineSprite = /*#__PURE__*/new WeakMap();
var _shipEngineThrusterSprite = /*#__PURE__*/new WeakMap();
var _Player_brand = /*#__PURE__*/new WeakSet();
class Player extends Phaser.GameObjects.Container {
  constructor(scene, eventBusComponent) {
    super(scene, scene.scale.width / 2, scene.scale.height - 32, []);
    _classPrivateMethodInitSpec(this, _Player_brand);
    _classPrivateFieldInitSpec(this, _keyboardInputComponent, void 0);
    _classPrivateFieldInitSpec(this, _healthComponent, void 0);
    _classPrivateFieldInitSpec(this, _weaponComponent, void 0);
    _classPrivateFieldInitSpec(this, _horizontalMovementComponent, void 0);
    _classPrivateFieldInitSpec(this, _colliderComponent, void 0);
    _classPrivateFieldInitSpec(this, _eventBusComponent, void 0);
    _classPrivateFieldInitSpec(this, _shipSprite, void 0);
    _classPrivateFieldInitSpec(this, _shipEngineSprite, void 0);
    _classPrivateFieldInitSpec(this, _shipEngineThrusterSprite, void 0);
    _classPrivateFieldSet(_eventBusComponent, this, eventBusComponent);
    this.scene.add.existing(this);
    this.scene.physics.add.existing(this);
    this.body.setSize(24, 24);
    this.body.setOffset(-12, -12);
    this.body.setCollideWorldBounds(true);
    this.setDepth(2);
    _classPrivateFieldSet(_shipSprite, this, scene.add.sprite(0, 0, 'ship'));
    _classPrivateFieldSet(_shipEngineSprite, this, scene.add.sprite(0, 0, 'ship_engine'));
    _classPrivateFieldSet(_shipEngineThrusterSprite, this, scene.add.sprite(0, 0, 'ship_engine_thruster'));
    _classPrivateFieldGet(_shipEngineThrusterSprite, this).play('ship_engine_thruster');
    this.add([_classPrivateFieldGet(_shipEngineThrusterSprite, this), _classPrivateFieldGet(_shipEngineSprite, this), _classPrivateFieldGet(_shipSprite, this)]);
    const connectedCog = (0, _CogManager.getConnectedCog)();
    _classPrivateFieldSet(_keyboardInputComponent, this, connectedCog ? new _cogInputComponent.CogInputComponent(this.scene) : new _keyboardInputComponent2.KeyboardInputComponent(this.scene));
    _classPrivateFieldSet(_horizontalMovementComponent, this, new _horizontalMovementComponent2.HorizontalMovementComponent(this, _classPrivateFieldGet(_keyboardInputComponent, this), CONFIG.PLAYER_MOVEMENT_HORIZONTAL_VELOCITY));
    _classPrivateFieldSet(_weaponComponent, this, new _weaponComponent2.WeaponComponent(this, _classPrivateFieldGet(_keyboardInputComponent, this), {
      speed: CONFIG.PLAYER_BULLET_SPEED,
      interval: CONFIG.PLAYER_BULLET_INTERVAL,
      lifespan: CONFIG.PLAYER_BULLET_LIFESPAN,
      maxCount: CONFIG.PLAYER_BULLET_MAX_COUNT,
      yOffset: -20,
      flipY: false
    }, _classPrivateFieldGet(_eventBusComponent, this)));
    _classPrivateFieldSet(_healthComponent, this, new _healthComponent2.HealthComponent(CONFIG.PLAYER_HEALTH));
    _classPrivateFieldSet(_colliderComponent, this, new _colliderComponent2.ColliderComponent(_classPrivateFieldGet(_healthComponent, this), _classPrivateFieldGet(_eventBusComponent, this)));
    _assertClassBrand(_Player_brand, this, _hide).call(this);
    _classPrivateFieldGet(_eventBusComponent, this).on(_eventBusComponent2.CUSTOM_EVENTS.PLAYER_SPAWN, _assertClassBrand(_Player_brand, this, _spawn), this);
    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => {
      this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this);
    }, this);
  }
  get colliderComponent() {
    return _classPrivateFieldGet(_colliderComponent, this);
  }
  get healthComponent() {
    return _classPrivateFieldGet(_healthComponent, this);
  }
  get weaponGameObjectGroup() {
    return _classPrivateFieldGet(_weaponComponent, this).bulletGroup;
  }
  get weaponComponent() {
    return _classPrivateFieldGet(_weaponComponent, this);
  }
  update(ts, dt) {
    if (!this.active) return;
    if (_classPrivateFieldGet(_healthComponent, this).isDead) {
      _assertClassBrand(_Player_brand, this, _hide).call(this);
      this.setVisible(true);
      _classPrivateFieldGet(_shipSprite, this).play({
        key: 'explosion'
      });
      _classPrivateFieldGet(_eventBusComponent, this).emit(_eventBusComponent2.CUSTOM_EVENTS.PLAYER_DESTROYED);
      return;
    }
    _classPrivateFieldGet(_shipSprite, this).setFrame((CONFIG.PLAYER_HEALTH - _classPrivateFieldGet(_healthComponent, this).life).toString(10));
    _classPrivateFieldGet(_keyboardInputComponent, this).update();
    _classPrivateFieldGet(_horizontalMovementComponent, this).update();
    _classPrivateFieldGet(_weaponComponent, this).update(dt);
  }
}
exports.Player = Player;
function _hide() {
  this.setActive(false);
  this.setVisible(false);
  _classPrivateFieldGet(_shipEngineSprite, this).setVisible(false);
  _classPrivateFieldGet(_shipEngineThrusterSprite, this).setVisible(false);
  _classPrivateFieldGet(_keyboardInputComponent, this).lockInput = true;
}
function _spawn() {
  this.setActive(true);
  this.setVisible(true);
  _classPrivateFieldGet(_shipEngineSprite, this).setVisible(true);
  _classPrivateFieldGet(_shipEngineThrusterSprite, this).setVisible(true);
  _classPrivateFieldGet(_shipSprite, this).setTexture('ship', 0);
  _classPrivateFieldGet(_healthComponent, this).reset();
  this.setPosition(this.scene.scale.width / 2, this.scene.scale.height - 32);
  _classPrivateFieldGet(_keyboardInputComponent, this).lockInput = false;
}